export const SERVICE_OPTIONS = [
  'Cookie Wow',
  'PDPA Form',
  'PDPA Prokit',
  'LearnPDPA',
  'PDPA Pro',
  'DPO Service'
] as const
